import React from 'react';

const MyItems = () => {
    return (
        <div>
            <h2>My Items</h2>
        </div>
    );
};

export default MyItems;